// extracted by mini-css-extract-plugin
export default {"homeContent__top":"c-i_cO","homeContent__bottom":"c-i_cP","homeContent__cardHolder":"c-i_cQ","homeContent__seoTextHolder":"c-i_cR"};